var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHexagon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 310,
    height: 323,
    viewBox: "0 0 310 323",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M239.829 33.0656C212.287 15.9083 198.516 7.32966 183.626 3.47711C171.16 0.251562 158.19 -0.546546 145.423 1.12626C130.173 3.12424 115.454 9.94973 86.0158 23.6007C57.3859 38.8746 43.0709 46.5116 32.2898 57.4799C23.2634 66.663 16.0872 77.4964 11.1521 89.3897C5.25777 103.595 3.80924 119.755 0.912145 152.075C-0.175201 184.506 -0.718888 200.722 3.38937 215.542C6.82899 227.951 12.6228 239.583 20.4552 249.803C29.8102 262.01 43.0809 271.345 69.6221 290.014C97.1647 307.171 110.936 315.75 125.825 319.602C138.291 322.828 151.261 323.626 164.029 321.953C179.278 319.955 193.997 313.13 223.436 299.479C252.066 284.205 266.381 276.568 277.162 265.6C286.188 256.416 293.364 245.583 298.299 233.69C304.194 219.484 305.642 203.324 308.539 171.005C309.627 138.573 310.17 122.358 306.062 107.537C302.623 95.1282 296.829 83.4968 288.996 73.2762C279.641 61.0689 266.371 51.7345 239.829 33.0656Z",
    fill: "#FFCD23"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHexagon2);
export default __webpack_public_path__ + "static/media/hexagon2.ec777d2ad6b4443ca987ed85a5beb095.svg";
export { ForwardRef as ReactComponent };